import axios from "../../utils/axiosConfig.js";
import { server } from "../../server/server";

// Load Current Organization
export const loadOrganization = () => async (dispatch) => {
  try {
    dispatch({ type: "LoadOrganizationRequest" });

    const { data } = await axios.get(`${server}/organization/load-organization`, {
      withCredentials: true,
    });

    dispatch({
      type: "LoadOrganizationSuccess",
      payload: data.organization,
    });

  } catch (error) {
    dispatch({
      type: "LoadOrganizationFail",
      payload: error.response?.data?.message || 'Something went wrong',
    });
  }
};

// Create Organization
export const createOrganization = (newOrganization) => async (dispatch) => {
  try {
    dispatch({ type: "createOrganizationRequest" });

    const { data } = await axios.post(`${server}/organization/create-organization`, newOrganization, { withCredentials: true });

    dispatch({
      type: "createOrganizationSuccess",
      payload: data.organization,
    });
  } catch (error) {
    dispatch({
      type: "createOrganizationFail",
      payload: error.response.data.message,
    });
  }
};

// Fetch All Organizations
export const getAllOrganizations = () => async (dispatch) => {
  try {
    dispatch({ type: "getAllOrganizationsRequest" });

    const { data } = await axios.get(`${server}/organization/get-all-organizations`, { withCredentials: true });

    dispatch({
      type: "getAllOrganizationsSuccess",
      payload: data.organizations,
    });
  } catch (error) {
    dispatch({
      type: "getAllOrganizationsFailed",
      payload: error.response.data.message,
    });
  }
};

// Fetch Single Organization
export const getOrganization = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getOrganizationRequest" });

    const { data } = await axios.get(`${server}/organization/get-organization/${id}`, { withCredentials: true });

    dispatch({
      type: "getOrganizationSuccess",
      payload: data.organization,
    });
  } catch (error) {
    dispatch({
      type: "getOrganizationFailed",
      payload: error.response.data.message,
    });
  }
};

// Edit Organization
export const editOrganization = (id, updatedData) => async (dispatch) => {
  try {
    dispatch({ type: "editOrganizationRequest" });

    const { data } = await axios.put(`${server}/organization/update-organization/${id}`, updatedData, { withCredentials: true });

    dispatch({
      type: "editOrganizationSuccess",
      payload: data.organization,
    });

    // Optionally, fetch all organizations again to update the list
    dispatch(getAllOrganizations());
  } catch (error) {
    dispatch({
      type: "editOrganizationFailed",
      payload: error.response.data.message,
    });
  }
};

// Delete Organization
export const deleteOrganization = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteOrganizationRequest" });

    const { data } = await axios.delete(`${server}/organization/delete-organization/${id}`, { withCredentials: true });

    dispatch({
      type: "deleteOrganizationSuccess",
      payload: data.message,
    });

    // Optionally, fetch all organizations again to update the list
    dispatch(getAllOrganizations());
  } catch (error) {
    dispatch({
      type: "deleteOrganizationFailed",
      payload: error.response.data.message,
    });
  }
};